interface SelectManagerSplashScreenProps {
  stepNumber: number
}

const SelectManagerSplashScreen = ({ stepNumber }: SelectManagerSplashScreenProps) => {
  return (
    <>
      {stepNumber === 1 && (
        <div className='min-h-screen bg-gradient-to-r from-amber-400 to-yellow-300 flex items-center justify-center relative overflow-hidden'>
          {/* 배경 장식 요소들 */}
          <div className='absolute top-20 left-10 w-16 h-16 bg-white/20 rounded-full animate-pulse'></div>
          <div className='absolute top-40 right-16 w-12 h-12 bg-white/15 rounded-full animate-pulse delay-300'></div>
          <div className='absolute bottom-32 left-20 w-20 h-20 bg-white/10 rounded-full animate-pulse delay-500'></div>
          <div className='absolute bottom-20 right-10 w-14 h-14 bg-white/20 rounded-full animate-pulse delay-700'></div>

          {/* 메인 콘텐츠 */}
          <div className='text-center z-10 px-8'>
            <div className='bg-white/90 backdrop-blur-sm rounded-3xl p-8 shadow-xl border border-white/30'>
              <div className='text-6xl mb-6 animate-bounce'>🐝</div>
              <h1 className='text-amber-900 text-xl font-bold leading-relaxed mb-2'>
                이제 너만의 상담사를
                <br />
                만나볼 차례야!
              </h1>
            </div>
          </div>
        </div>
      )}
      {stepNumber === 2 && (
        <div className='min-h-screen bg-gradient-to-r from-amber-400 to-yellow-300 flex items-center justify-center relative overflow-hidden'>
          {/* 배경 장식 요소들 */}
          <div className='absolute top-16 left-8 w-24 h-24 bg-white/20 rounded-full animate-pulse'></div>
          <div className='absolute top-32 right-12 w-16 h-16 bg-white/15 rounded-full animate-pulse delay-200'></div>
          <div className='absolute bottom-40 left-16 w-20 h-20 bg-white/10 rounded-full animate-pulse delay-400'></div>
          <div className='absolute bottom-24 right-8 w-18 h-18 bg-white/20 rounded-full animate-pulse delay-600'></div>

          {/* 메인 콘텐츠 */}
          <div className='text-center z-10 px-8'>
            <div className='bg-white/90 backdrop-blur-sm rounded-3xl p-8 shadow-xl border border-white/30'>
              <div className='flex justify-center mb-6'>
                <div className='relative'>
                  <div className='text-4xl animate-spin-slow'>🔍</div>
                  <div className='absolute -top-2 -right-2 text-2xl animate-bounce delay-300'>✨</div>
                </div>
              </div>
              <h1 className='text-amber-900 text-xl font-bold leading-relaxed mb-2'>
                너와 잘 맞을 것 같은
                <br />
                상담사는...
              </h1>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default SelectManagerSplashScreen
